import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class FiltroAvancadoService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(private tokenService: TokenService, private http: HttpClient) { }

  getFiltrosAvancados(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/chamados/filtro-avancado/dropdownlist`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getStatus(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/chamados/filtro/dropdownlist`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropDownData(param): Observable<any> {
    this.httpOptions.params = param
    return this.http.get(`${this.apiUrl}api/chamados/filtro-avancado/dropdown-data`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  adicionarFiltro(payload): Observable<any> {
    this.httpOptions.params = ''
    return this.http.post(`${this.apiUrl}api/chamados/filtro-avancado/salvar`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizarFiltro(payload): Observable<any> {
    this.httpOptions.params = ''
    return this.http.put(`${this.apiUrl}api/chamados/filtro-avancado/salvar`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  excluirFiltro(id): Observable<any> {
    this.httpOptions.params = ''
    return this.http.delete(`${this.apiUrl}api/chamados/filtro-avancado/excluir/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  obterFiltro(id): Observable<any> {
    this.httpOptions.params = ''
    return this.http.get(`${this.apiUrl}api/chamados/filtro-avancado/obter/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  listarFiltros(params, filtros): Observable<any> {
    this.httpOptions.params = params
    return this.http.post(`${this.apiUrl}api/chamados/filtro-avancado/listar`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropDownCampos(): Observable<any> {
    this.httpOptions.params = ''
    return this.http.get(`${this.apiUrl}api/chamados/filtro-avancado/dropdown-campos`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
